import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subsFilter'
})
export class SubsFilterPipe implements PipeTransform {

  transform(subsList: Array<any>, activeSubs: any, type: any = ""): Array<any> {
    let finalArray: Array<any> = JSON.parse(JSON.stringify(subsList));
    if (!type) {
      const isSameCommissionType = (item: any) => !!item.isCommission === !!activeSubs.isCommission;
      if (activeSubs?.tier === 'tier2') {
        // Pro subscriber (any Pro plan, old ones included): only their Pro plan
        finalArray = finalArray.filter(item => item.tier === 'tier2' && isSameCommissionType(item));
      } else if (activeSubs?.tier === 'tier1') {
        // Premium subscriber (any Premium plan, old ones included): their Premium plan + Pro with commission (monthly / annual)
        finalArray = finalArray.filter(item =>
          (item.tier === 'tier1' && isSameCommissionType(item)) || (item.tier === 'tier2' && item.isCommission));
      }
    } else {
      finalArray =  finalArray.filter((item: any) => {
        if (item.planName === 'Pro Plan' && item.isCommission) {
          item.order = 3;
        } else if (item.planName === 'Premium Plan' && !item.isCommission) {
          item.order = 2;
        }
        return item;
      });
      if (activeSubs &&  activeSubs?.tier !== "tier0") {
        const activeIndex = finalArray.findIndex((item) => item.isActive === true);
        if (activeIndex > -1) {
          const [activeItem] = finalArray.splice(activeIndex, 1);
          activeItem.order = finalArray[0].order + activeItem.order;
          finalArray[0].order = activeItem.order - finalArray[0].order;
          activeItem.order = activeItem.order - finalArray[0].order;
          finalArray.unshift(activeItem);
        }
        finalArray = this.showHideBtn( activeSubs, finalArray )
      }
    }
    // Only sort for compare list
    if(type === "compare") {
      // Find and separate active plan
      const activePlan = finalArray.find((item) => item.isActive === true);
      let sortedList = finalArray.filter((item) => !item.isActive);
      sortedList = sortedList.sort((a, b) => (a.price || 0) - (b.price || 0));
      if (activePlan) {
        sortedList.unshift(activePlan);
      }
      // Update order property based on sorted index
      sortedList.forEach((item, index) => {
        item.order = index;
      });
      finalArray = sortedList;
    }
    return finalArray;
  }


  showHideBtn(activeSubs: any, subsArray: Array<any>) {
    let finalArray: Array<any> = [];
    if (activeSubs && !activeSubs.isCommission ) {
      if (activeSubs.tier === 'tier2') {
          finalArray =  subsArray.filter(item =>  {
            if (item.id ===  "0004") {
              item.isShowPlan = false;
            } else if (item.tier ===  "tier1") {
              item.isShowButton = false;
            } else if ( item.tier ===  "tier2" && item?.isCommission) {
               item.isShowButton = false;
            } 
            return item;
          });
      } else {
        finalArray = subsArray.filter(item =>  {
            if (item.id ===  "0004") {
              item.isShowPlan = false;
            } else if (item.tier ===  "tier1" && item?.isCommission) {
              item.isShowButton = false;
            } else if ( item.tier ===  "tier2" && item?.isCommission) {
               item.isShowButton = false;
            } 
            return item;
          });
      }
    } else if (activeSubs && activeSubs.isCommission && activeSubs.frequency !== "monthly") {
        if(activeSubs.tier === 'tier2'){
          finalArray = subsArray.filter(item =>  {
            if (item.id ===  "0001") {
              item.isShowButton = false;
            }
            return item;
          });
        } else {
          finalArray = subsArray;
        }
    } else {
      finalArray = subsArray;
    }
    return finalArray;
  }

}
